import React from 'react';

const initialState = {
    active: 1
};


export default function (state = initialState, action) {
    switch (action.type) {
        case 'SET_ACTIVE': {
            return {...state, active: action.payload};
        }
        default: {
            return state;
        }
    }
}
